// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fVnL","footer":"styles_footer__2-nQZ"};